import React from 'react';
import { Select, Form } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const Option = Select.Option;
const AppliancesTypes = ({ form, appliancesTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Удобства">
      {getFieldDecorator('appliance_key')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите опции"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {appliancesTypes &&
            appliancesTypes.map(type => (
              <Option
                key={type.applianceKey}
                value={type.applianceKey}
                label={type.applianceName}
              >
                {type.applianceName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default transportFieldsConnect(AppliancesTypes, ['appliancesTypes']);
